"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const country_code_lookup_1 = require("country-code-lookup");
const merlin_map_1 = require("@travelnest/merlin.map");
const autosave_1 = require("../../../../hooks/autosave");
const validation_1 = require("../../../../hooks/validation");
const TaskPage_1 = require("../../base/TaskPage");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const merlin_select_1 = require("@travelnest/merlin.select");
const FormInput_1 = require("../../../components/input/text/FormInput");
const constants_1 = require("../../../../tasks/constants");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const lodash_1 = require("lodash");
const api_1 = __importDefault(require("../../../../api"));
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const Heading_1 = require("../../../components/heading/Heading");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const fullStory_1 = require("../../../../util/fullStory");
const sortedCountries = country_code_lookup_1.countries.sort((a, b) => a.country > b.country ? 1 : -1);
const DEFAULT_COUNTRY = 'GB';
// We have to wrap the Google Map with an absolute height as it fills to 100% height of its parent
const MapWrapper = styled_1.default.div `
	height: 35rem;
`;
const addressFromProperty = (property) => {
    if (!property)
        return {};
    const { address1, address2, city, postcode, country_code } = property;
    return { address1, address2, city, postcode, country_code };
};
const normaliseCoords = (coords) => {
    const fixedLat = Number.parseFloat(coords.lat.toFixed(5));
    const fixedLng = Number.parseFloat(coords.lng.toFixed(5));
    return { latitude: fixedLat, longitude: fixedLng };
};
const getUpdatedCoords = (0, lodash_1.debounce)((newAddress, updateFn) => __awaiter(void 0, void 0, void 0, function* () {
    const newCoords = yield api_1.default.googleMaps.getCoordinatesByAddress(newAddress);
    updateFn(normaliseCoords(newCoords));
}), 2500, { trailing: true });
exports.default = (props) => {
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [mapLocationChanged, setMapLocationChanged] = React.useState(false);
    const propertyAddress = addressFromProperty(property);
    const prevPropertyAddress = (0, merlin_hooks_1.usePrevious)(propertyAddress);
    React.useEffect(() => {
        if (!!prevPropertyAddress && !(0, lodash_1.isEqual)(prevPropertyAddress, propertyAddress)) {
            getUpdatedCoords(addressFromProperty(property), update);
        }
    }, [propertyAddress, update]);
    const [addressValid, addressError] = (0, validation_1.usePropertyValidation)('address1', property);
    const [address2Valid, address2Error] = (0, validation_1.usePropertyValidation)('address2', property);
    const [cityValid, cityError] = (0, validation_1.usePropertyValidation)('city', property);
    const [postcodeValid, postcodeError] = (0, validation_1.usePropertyValidation)('postcode', property);
    (0, validation_1.usePropertyValidation)('latitude', property);
    (0, validation_1.usePropertyValidation)('longitude', property);
    const onMapChange = (lat, lng) => {
        const fixedLat = Number.parseFloat(lat.toFixed(5));
        const fixedLng = Number.parseFloat(lng.toFixed(5));
        update({ 'latitude': fixedLat, 'longitude': fixedLng });
        if (!mapLocationChanged) {
            setMapLocationChanged(true);
            (0, fullStory_1.sendCustomFullStoryEvent)('location_page_map_change', {
                mapLocationChanged
            });
        }
    };
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.LOCATION, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { "data-testid": "location-page" },
            React.createElement(TaskPage_1.TaskColumn, { width: 50 },
                React.createElement(HorizontalRule_1.HorizontalRule, null),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(merlin_select_1.Select, { label: "Country", id: "property-country-select", value: (property === null || property === void 0 ? void 0 : property.country_code) || DEFAULT_COUNTRY, onChange: (e) => update({ country_code: e.target.value }) }, sortedCountries.map((c, i) => React.createElement("option", { key: i, value: c.iso2 }, c.country)))),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(HorizontalRule_1.HorizontalRule, null),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement("div", { role: "group", "aria-labelledby": "property-address-heading" },
                        React.createElement(Heading_1.Heading, { id: "property-address-heading" }, "Step 1: Add full property address"),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(FormInput_1.FormInput, { label: "Address line 1", id: "address_1", value: property === null || property === void 0 ? void 0 : property.address1, onChange: (e) => update({ address1: e.target.value }), valid: addressValid, errorMessage: addressError, noCharCount: true }),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(FormInput_1.FormInput, { label: "Address line 2", id: "address_2", value: property === null || property === void 0 ? void 0 : property.address2, onChange: (e) => update({ address2: e.target.value }), valid: address2Valid, errorMessage: address2Error, noCharCount: true }),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(FormInput_1.FormInput, { label: "City", id: "address_city", value: property === null || property === void 0 ? void 0 : property.city, onChange: (e) => update({ city: e.target.value }), valid: cityValid, errorMessage: cityError, noCharCount: true }),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(FormInput_1.FormInput, { label: "Postcode", id: "address_postcode", value: property === null || property === void 0 ? void 0 : property.postcode, onChange: (e) => update({ postcode: e.target.value }), valid: postcodeValid, errorMessage: postcodeError, noCharCount: true }))),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(HorizontalRule_1.HorizontalRule, null),
                React.createElement(Spacer_1.Spacer, { spacing: "large" })),
            React.createElement(TaskPage_1.TaskColumn, { width: 50 },
                React.createElement(HorizontalRule_1.HorizontalRule, null),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement("div", { role: "group", "aria-labelledby": "property-map-heading" },
                        React.createElement(Heading_1.Heading, { id: "property-map-heading" }, "Step 2: Select pin location"),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(Paragraph_1.Paragraph, null, "Help guests find your property by selecting the correct pin location on the map below."),
                        React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                        React.createElement(MapWrapper, { "data-testid": "location-page-map" },
                            React.createElement(merlin_map_1.Map, { lat: property === null || property === void 0 ? void 0 : property.latitude, lng: property === null || property === void 0 ? void 0 : property.longitude, onChange: onMapChange, interactive: true }))))))));
};
//# sourceMappingURL=LocationPage.js.map